export default __webpack_public_path__ + "static/media/sector-3.ecd24c69.gif";